
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
import textTraderTitle from '~/components/textTrader/_title.vue'
export default {
  components: {
    'text-title': textTraderTitle
  },
  inject: ['info'],
  data() {
    const _ismt5 = this.info && this.info.softwareInfo && this.info.softwareInfo.softwareType == 2
    const _ismt4 = this.info && this.info.softwareInfo && this.info.softwareInfo.softwareType == 1
    const _isziyan = this.info && this.info.softwareInfo && this.info.softwareInfo.softwareType == 4
    return {
      ismt5: _ismt5,
      ismt4: _ismt4,
      isziyan: _isziyan,
      showall: false,
      showArrow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == 'tiyan' || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('移动端平台测试1')
  },
  methods: {
    show(mark) {
      this.showall = mark
    },
    DealTraderName(content, type) {
      if (!content) {
        return ''
      }
      let ret = content
      if (type == 'text') {
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      } else {
        ret = ret.replace('{brokers name}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace('{0}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      }
      return ret
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
